import type { EditorView } from '@codemirror/view';
import { wrapSelection, insertLink, prefixLine, insertCode } from './commands';

interface Props {
  view: EditorView | null;
}

export function EditorToolbar(props: Props) {
  const run = (fn: (v: EditorView) => boolean) => () => {
    if (props.view) fn(props.view);
  };
  return (
    <div class="editor-toolbar">
      <button onClick={run((v) => wrapSelection(v, '**'))} title="Bold (⌘B)"><b>B</b></button>
      <button onClick={run((v) => wrapSelection(v, '*'))} title="Italic (⌘I)"><i>I</i></button>
      <button onClick={run((v) => wrapSelection(v, '~~'))} title="Strikethrough (⌘⇧X)"><s>S</s></button>
      <span class="sep" />
      <button onClick={run((v) => insertCode(v))} title="Code (inline if single line; fenced if multi-line / empty)">{'<>'}</button>
      <button onClick={run((v) => insertLink(v))} title="Link">link</button>
      <span class="sep" />
      <button onClick={run((v) => prefixLine(v, '# '))} title="Heading 1">H1</button>
      <button onClick={run((v) => prefixLine(v, '## '))} title="Heading 2">H2</button>
      <button onClick={run((v) => prefixLine(v, '- '))} title="Bullet list">•</button>
      <button onClick={run((v) => prefixLine(v, '1. '))} title="Numbered list">1.</button>
      <button onClick={run((v) => prefixLine(v, '> '))} title="Blockquote">"</button>
    </div>
  );
}
